










































/* eslint-disable @typescript-eslint/no-explicit-any */
import Vue from 'vue';
import axios from '@/plugins/axios';
import { API_SEARCH_HIMMOKU } from '@/constants/api';
import CtrlNumTxt from '@/components/common/control/CtrlNumTxt.vue';
import CtrlSearchBtn from '@/components/common/control/CtrlSearchBtn.vue';
import ListHimmoku from '@/components/common/search/ListHimmoku.vue';
import { noDataError, clearNoDataError } from '@/utils/message';
import { UmuFlg } from '@/constants/constants';

export default Vue.extend<any, any, any, any>({
  name: 'CtrlHimmoku',
  components: {
    CtrlNumTxt,
    CtrlSearchBtn,
    ListHimmoku,
  },
  props: {
    // cancel の時の呼出元の処理（共通）
    callbackCancel: {
      type: Function,
    },
    // OKの時の呼出元の処理（共通）
    callbackOk: {
      type: Function,
    },
    // 呼出元が選択情報を取得する callback function
    callbackGetHimmokuData: {
      type: Function,
    },
    // control の label（共通）
    label: {
      type: String,
      default: '品目',
    },
    // code 入力部の幅（共通）
    widthCd: {
      type: Number,
      default: 63,
    },
    // 名用表示部の幅（共通）
    widthName: {
      type: Number,
      default: 425,
    },
    // 必須設定（共通)
    required: {
      type: Boolean,
      default: false,
    },
    // 読取専用（共通）
    readonly: {
      type: Boolean,
      default: false,
    },
    // 見積有無フラグ
    mitsumoriUmuFlg: {
      type: Boolean,
      default: false,
    },
    // 品目種類パターン
    himmokuShuruiPtn: {
      type: Number,
    },
    // 業種コード
    gyoshuCd: {
      type: Number,
    },
    // 売上可否区分
    uriageKahiKb: {
      type: Number,
    },
    // 在庫管理区分
    zaikoKanriKb: {
      type: Number,
    },
    // 仕入先コード
    shiiresakiCd: {
      type: Number,
    },
    // 原料仕入先コード
    genryoShiiresakiCd: {
      type: Number,
    },
    // 事業所コード
    jigyoshoCd: {
      type: Number,
    },
    // 納品先コード
    nohinsakiCd: {
      type: Number,
    },
    // 得意先コード
    tokuisakiCd: {
      type: Number,
    },
    // 配送区分
    haisoKb: {
      type: Number,
    },
    // 無効有無フラグ
    mukoUmuFlg: {
      type: Number,
    },
  },
  data: () => ({
    API_SEARCH_HIMMOKU,
    listHimmokuShow: false,
    himmokuCd: 0,
    himmokuRyakuMei: '',
    himmokuMei1: '',
    himmokuMei2: '',
    errors: {
      errorMessages: '',
    },
    isNoData: false,
  }),
  computed: {
    styleItemName() {
      return {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        width: `${this.widthName}px`,
        color: 'rgba(0, 0, 0, 0.87)',
        cursor: 'default',
      };
    },
  },
  methods: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    handleOk(item: any) {
      const { himmokuCd, himmokuRyakuMei, himmokuMei1, himmokuMei2 } = item;
      this.himmokuCd = himmokuCd;
      this.himmokuRyakuMei = himmokuRyakuMei;
      this.himmokuMei1 = himmokuMei1;
      this.himmokuMei2 = himmokuMei2;
      this.listHimmokuShow = false;
      this.errors.errorMessages = '';
      this.callbackOk && this.callbackOk(item);
      this.isNoData = false;
    },
    handleCancel() {
      this.listHimmokuShow = false;
      this.callbackCancel && this.callbackCancel();
    },
    handleChange(value: number) {
      this.himmokuCd = value;
      if (value) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.getHimmokuItem();
      } else {
        this.himmokuRyakuMei = '';
        this.himmokuMei1 = '';
        this.himmokuMei2 = '';
        this.errors = clearNoDataError();
        // IDをクリアするとデータをリセットする
        this.callbackOk && this.callbackOk({ himmokuCd: this.himmokuCd });
      }
    },

    getHimmokuItem() {
      // #886086 s 手入力した際の API の parameter が不足している
      const params: any = { himmokuCd: this.himmokuCd };
      if (this.himmokuShuruiPtn !== undefined && this.himmokuShuruiPtn > 0) {
        params.himmokuShuruiPtn = this.himmokuShuruiPtn;
      }
      if (this.gyoshuCd !== undefined) {
        params.gyoshuCd = this.gyoshuCd;
      }
      if (this.uriageKahiKb !== undefined) {
        params.uriageKahiKb = this.uriageKahiKb;
      }
      if (this.zaikoKanriKb !== undefined) {
        params.zaikoKanriKb = this.zaikoKanriKb;
      }
      if (this.shiiresakiCd !== undefined && this.shiiresakiCd > 0) {
        params.shiiresakiCd = this.shiiresakiCd;
      }
      if (this.genryoShiiresakiCd !== undefined && this.genryoShiiresakiCd > 0) {
        params.genryoShiiresakiCd = this.genryoShiiresakiCd;
      }
      if (this.jigyoshoCd !== undefined && this.jigyoshoCd > 0) {
        params.jigyoshoCd = this.jigyoshoCd;
      }
      if (this.nohinsakiCd !== undefined && this.nohinsakiCd > 0) {
        params.nohinsakiCd = this.nohinsakiCd;
      }
      if (this.tokuisakiCd !== undefined && this.tokuisakiCd > 0) {
        params.tokuisakiCd = this.tokuisakiCd;
      }
      if (this.haisoKb !== undefined) {
        params.haisoKb = this.haisoKb;
      }
      if (this.mukoUmuFlg !== undefined) {
        params.mukoUmuFlg = this.mukoUmuFlg;
      }
      if (this.mitsumoriUmuFlg) {
        params.mitsumoriUmuFlg = UmuFlg.ARI;
      } else {
        params.mitsumoriUmuFlg = UmuFlg.NASHI;
      }
      // #886086 e

      axios
        //.get(API_SEARCH_HIMMOKU, { params: { himmokuCd: this.himmokuCd } }) // #886086
        .get(API_SEARCH_HIMMOKU, { params: params }) // #886086
        .then((res) => {
          if (!res.data.responseData || res.data.responseData.length === 0) {
            this.himmokuRyakuMei = '';
            this.himmokuMei1 = '';
            this.himmokuMei2 = '';
            this.isNoData = true;
            this.errors = noDataError();
            this.callbackOk && this.callbackOk({ himmokuCd: this.himmokuCd });
            return;
          }
          this.errors = clearNoDataError();
          const { himmokuRyakuMei, himmokuMei1, himmokuMei2 } = res.data.responseData[0];
          this.himmokuRyakuMei = himmokuRyakuMei;
          this.himmokuMei1 = himmokuMei1;
          this.himmokuMei2 = himmokuMei2;
          this.callbackGetHimmokuData &&
            this.callbackGetHimmokuData(res.data.responseData[0]);
          this.isNoData = false;
        });
    },
  },
  watch: {
    // 呼び出し元の tag の 引数 [himmokuCd] に bind している変数 を監視する
    // 変数が、input 以外の event で値変更された時に、その値を control に set
    '$attrs.himmokuCd': {
      handler(newValue) {
        if (+newValue === +this.himmokuCd) return;
        this.himmokuCd = +newValue;
        if (newValue) {
          this.getHimmokuItem();
        } else {
          this.himmokuRyakuMei = '';
          this.himmokuMei1 = '';
          this.himmokuMei2 = '';
          this.errors = clearNoDataError();
        }
      },
    },
  },
  created() {
    if (this.$attrs.himmokuCd) {
      this.himmokuCd = +this.$attrs.himmokuCd;
    }
  },
});
